import React from "react";
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";

const Graph = ({ title, data, timeFilter }) => {
    const aggregateDataByMonth = (data) => {
        if (!data) return [];
        const monthlyData = {};

        data.forEach(item => {
            const monthKey = item.date.substring(0, 7); // Get YYYY-MM
            if (!monthlyData[monthKey]) {
                monthlyData[monthKey] = { date: monthKey, count: 0 };
            }
            monthlyData[monthKey].count += item.count;
        });

        return Object.values(monthlyData).sort((a, b) => a.date.localeCompare(b.date));
    };

    const displayData = timeFilter === 'month' ? aggregateDataByMonth(data) : data;

    return (
        <div className="graph-container">
            <div className="graph-header">
                <h3>{title}</h3>
            </div>
            <ResponsiveContainer width="100%" height={400}>
                <LineChart
                    data={displayData}
                    margin={{ top: 20, right: 30, left: -20, bottom: 5 }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="count" stroke="#18a0fb" activeDot={{ r: 8 }} />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default Graph;
